export const AppConstant = {
    BASE_URL: "https://oc4cc5799d.execute-api.ap-southeast-2.amazonaws.com/prod/api",
    IMAGE_BASE_URL: "https://d1rm4dg6zsnjq3.cloudfront.net/",

    //BASE_URL: "https://7uxxynt4kf.execute-api.us-east-1.amazonaws.com/prod/api",

    //BASE_URL: "http://localhost:5005/api",
    // IMAGE_BASE_URL: "http://localhost:5005/",
    isDeliveryPriceShow: false,
    isBatteryShow: false,
    zipPayload: "zipPayload",
    currencySymbol: "$",
    percentageSymbol: "%",
    loginId: "loginId",
    authToken: "authToken",
    userName: "userName",
    userEmail: "userEmail",
    CART_KEY: "cart",
    timerEnd: "timerEnd",
    comingFromLogin: "comingFromLogin",
    userSelectedCityId: "userSelectedCityId",
    userSelectedSuburb: "userSelectedSuburb",
    locationPopupShow: "locationPopupShow",
    cacheBrands: "cache_brands",
    cacheVhicleTypes: "cache_vehicle_types",
    cacheStates: "cache_states",
    cacheSuburbs: "cache_suburbs",
    cacheSocialMedia: "cache_social_media",
    cacheDynamicServices: "cache_dynamic_services",
    cacheCompanyInfos: "cache_company_infos",
    cacheModels: "cache_models",

    productListPath: "/products/",
    slugPrefix: "slug--",
    categoryPrefix: "category--",
    brandPrefix: "brand--",
    vehicleTypePrefix: "vehicle type--",

    tyreWidth: 4,
    tyreProfile: 5,
    tyreRim: 6,
    tyreLoadIndex: 9,
    tyreSpeedRating: 10,

    wheelCenterBore: 11,
    wheelBoltPattern: 12,
    wheelMaterial: 13,
    wheelSize: 14,
    wheelOffset: 15,

    paymentWebSetting: 2,
    paymentOnsite: "Onsite",
    paymentStrip: "Stripe",
    paymentZip: "Zip pay",

    taxIdFromBackend: "68133932b12ee5b69afab736",
    taxPercentageFromBackend: 10,

    pickUpPriceMsg: "That's just the Innings Score! Fitting fees are the extra run costs.",
    confirmDeleteOtherItem: "Confirm to delete other items",
    confirmDeleteOtherItemMsgs: "You can not club Store items and Mobile items together in same order. you can only make store or mobile fitting order at one time.Do you want to delete all other items from cart and add it?",
    emptyCart: "Yes, Empty Cart",
    keepExisting: "No, Keep Existing",
    // productSlugPattern: /^\d{2,3}-\d{2,3}-\d{2,3}$/,
    productSlugPattern: /^[0-9]+(?:\.[0-9]+)?(?:[xX][0-9]+(?:\.[0-9]+)?)*(?:-[0-9]+(?:\.[0-9]+)?(?:[xX\/][0-9]+(?:\.[0-9]+)?)*)*$/,
    get includesGST() {
        return `(Includes ${this.taxPercentageFromBackend}${this.percentageSymbol} GST)`;
    },
    pickUpPrice: "Pick up price",
    isMaintenance: false,
    tollFreeNumber: "1300683881"
}